import fetch from './fetch'

export default {
  getPersonRecordCount (payload) {
    let request = fetch({
      url: `/model/person/count`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getPersons (payload) {
    let request = fetch({
      url: `/person/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getDashboardSearchPersons (payload) {
    let request = fetch({
      url: `/dashboard/person/search/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getPerson (payload) {
    let request = fetch({
      url: `/person/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createPerson (payload) {
    let request = fetch({
      url: `/person/`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  updatePerson (payload) {
    const personId = payload._id
    const toOmit = [
      'id',
      '_id',
      'sharingRecords',
      'sharingGroups',
      'createdAt',
      'createdBy',
      'timestamp',
      'updatedAt',
      'updatedBy',
      'externalPersonIds'
    ]
    const data = _.omit(payload, toOmit)

    // Flatten our associations
    const associations = [
      'organization'
    ]
    _.each(associations, function (assoc) {
      // We forgot to flatten our assocation(s)
      if (data[assoc] && _.isObject(data[assoc])) {
        data[assoc] = data[assoc].id
      } else {
        delete data[assoc]
      }
    })

    let request = fetch({
      url: `/person/` + personId,
      method: 'patch',
      data: data
    })

    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/person.js